import { jsx as e } from "react/jsx-runtime";
// lib/components/CropDialog/VisualCrop.tsx
var t = ({ crop: t }) => /* @__PURE__ */ e("div", {
	className: "absolute inset-0 bg-black bg-opacity-30 pointer-events-none",
	style: { clipPath: `polygon(
          0% 0%,
          0% 100%,
          ${t.x * 100}% 100%,
          ${t.x * 100}% ${t.y * 100}%,
          ${(t.x + t.w) * 100}% ${t.y * 100}%,
          ${(t.x + t.w) * 100}% ${(t.y + t.h) * 100}%,
          ${t.x * 100}% ${(t.y + t.h) * 100}%,
          ${t.x * 100}% 100%,
          100% 100%,
          100% 0%
        )` }
});
export { t as VisualCrop };
